import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-pause',
  templateUrl: './pause.component.html',
  styleUrls: ['./pause.component.css']
})
export class PauseComponent implements OnInit {

  @Output() listChanged = new EventEmitter();
  public turn: object;
  public pausedList: any[] = [];

  private destroy$ = new Subject();
  private autoSupervisorInterval: any = null;

  constructor(public _data: DataService,
    private _blogic: BusinesLogicService,
    private _utils: UtilsService,
    private _modal: ModalHelper) { }

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );

    this._getPausedList();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* When the turn information change */
  private _updateTurn(turn: object): void {
    if (!this._data.turnIsActive()) {
      this.turn = null;
    } else {
      this.turn = turn;
    }
  }

  /* Pause the actual turn */
  public pause(): void {

    let params: object = {
      desk_id: this._data.session["desk"],
      turn_id: this._data.turn["id"],
      pause: true,
      deskuser: this._data.session["username"]
    };

    this._blogic.setPausedTicket(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          this._data.closeTurn();
          this._getPausedList();
        }
      );
  }

  /* Recovery paused turn */
  public recovery(id: number): void {
    let params: object = {
      desk_id: this._data.session["desk"],
      turn_id: id,
      pause: false,
      deskuser: this._data.session["username"]
    };
    this._data.pauseModalTurn = true;
    this._blogic.setPausedTicket(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          this.getTurn();
          this._getPausedList();
          this._modal.hide("pausedModal");
        }
      );
  }

  /* Get the paused turn list */
  private _getPausedList(): void {
    let params: object = {
      desk_id: this._data.session["desk"]
    };

    this._blogic.getDeskPaused(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.pausedList = response;
        }
      );
  }

  /* Get a turn */
  public getTurn(): void {
    let params: object = {
      desk_id: this._data.session["desk"],
      status: "query"
    };

    this._blogic.deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.turn = response;
        }
      );
  }

  public getTurnNoPause() : void {
    let params: object = {
      desk_id: this._data.session["desk"],
      status: "A",
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"],
    };

    this._blogic.deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.listChanged.emit(true);
          if (response == null) {
            this._data.closeTurn();
          } else {
            this._data.turn = response;
          }
        }
      );
  }

  /* Open paused modal */
  public openPausedModal(): void {
    this._data.pauseModalTurn = true;
    this._modal.show("pausedModal");
    let self = this;
    $('#pausedModal').on('hidden.bs.modal', function (e) {
      self._data.pauseModalTurn = false
      if(self._data.session['autosupervisor']){
        self.autoSupervisorInterval = setTimeout(() => {
          self.getTurnNoPause();
        }, parseInt((self._data.session['autosupervisor_delaytime'])) * 1000);
      }
    });
  }

}
